import * as React from "react";
import { Tennis as Scoreboard } from "sb-resp-ui";
import { EventCell } from "../EventCell";
import { EventName } from "../EventName";
import { EventTextTypeModifiers } from "../../../../data";
import { returnValueHelper, getValueHelper, getMBNComponentHelper } from "../../../../helpers";
export function EventInfoMultipleItems(eventObj) {
    let eventNameObj1 = {
        eventObj,
        onService: returnValueHelper(eventObj.onService === "1", true, false),
        timeStampMdf: eventObj.modifierDatePeriodTimes,
        textTimeScoreText: eventObj.textDatePeriodTime,
        eventTextTypeMdf: returnValueHelper(!!eventObj.pickedEvent.IsOutright, EventTextTypeModifiers.modifierEventName, EventTextTypeModifiers.modifierTeamName),
        eventText: returnValueHelper(!!eventObj.pickedEvent.IsOutright, eventObj.event.eventName, eventObj.event.team1Name)
    };
    let eventNameObj2 = {
        eventObj,
        onService: returnValueHelper(eventObj.onService === "2", true, false),
        timeStampMdf: eventObj.modifierTimeScore,
        textTimeScoreText: eventObj.textTimeScore,
        eventTextTypeMdf: returnValueHelper(!!eventObj.pickedEvent.IsOutright, EventTextTypeModifiers.modifierEachWay, EventTextTypeModifiers.modifierTeamName),
        eventText: returnValueHelper(!!eventObj.pickedEvent.IsOutright, eventObj.market.eachWayText, eventObj.event.team2Name)
    };
    let eventHasStartedLiveScb = eventObj.eventHasStarted && eventObj.hasLiveScb;
    let shouldMBNRender = eventObj.isMBNEnabled && eventObj.pickedEvent.IsOutright;
    const mbnObj = getMBNComponentHelper(shouldMBNRender, eventObj.pickedEvent);
    return (React.createElement(React.Fragment, null,
        getValueHelper(eventHasStartedLiveScb, React.createElement(Scoreboard, Object.assign({}, eventObj.scoreboardProps))),
        React.createElement(EventCell, null,
            EventName(eventNameObj1, eventHasStartedLiveScb),
            EventName(eventNameObj2, eventObj.hasLiveScb, mbnObj))));
}
//# sourceMappingURL=EventInfoMultipleItems.js.map